module.exports = __webpack_public_path__ + "static/media/documentation.1f7437c4.md";